import script from "./admin-antiCounterfeiting.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-antiCounterfeiting.vue?vue&type=script&setup=true&lang=js"

import "./admin-antiCounterfeiting.vue?vue&type=style&index=0&id=b6e98b5c&scoped=true&lang=scss"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6e98b5c"]])

export default __exports__